import { Component, OnInit, ViewChild, ElementRef   } from '@angular/core';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { CookieXSRFStrategy } from '@angular/http';
import { Routes, RouterModule, Router } from '@angular/router';
import { ToastService } from 'ng-uikit-pro-standard';
import { CompanySettingsService } from 'src/app/services/company-settings.service';
import { MapInformationService } from 'src/app/services/map-information.service';

import { RecaptchaComponent } from 'ng-recaptcha';

@Component({
  selector: 'app-company-registration',
  templateUrl: './company-registration.component.html',
  styleUrls: ['./company-registration.component.scss']
})
export class CompanyRegistrationComponent implements OnInit {
  // @ViewChild('modalSendEmail', { static: true }) modalSendEmail!: ModalDirective;
  @ViewChild('openModalBtn', { static: false }) openModalBtn!: ElementRef<HTMLButtonElement>;

  cardForm1: FormGroup;
  Torganizacion: Array<any>;
  nuser:Array<any>;
  public _formEntity: FormGroup;
  optionsType: any;
  companyTypes: any;
  mycatchaResponse: any;  
  popupSendEmail: boolean = false;

  public resolved(captchaResponse: string): void {
    console.log(`Resolved captcha with response: ${captchaResponse}`);
    this.mycatchaResponse = captchaResponse;
  }

  public onError(errorDetails: string): void {
    console.log(`reCAPTCHA error encountered; details:`, errorDetails);
  }    

  constructor(private fb: FormBuilder, private router: Router, private toastrService: ToastService, private settings: CompanySettingsService, private toast: ToastService, public MapInformationService:MapInformationService) {

    this.cardForm1 = fb.group({
      firtsname: ['', Validators.required],
      lastname: ['', Validators.required],
      organame: ['', Validators.required],
      pnum: ['', Validators.required]
    });

   }

   formData = {
    clientfirstname: '',
    clientlastname: '',
    clientemail: '',
    clientorganizationname: '',
    clientphonenumber: '',
    clientorganizationtype: '',
    clientnumberofusers: '0'
  };
  
  validationErrors = {
    clientfirstname: false,
    clientlastname: false,
    clientemail: false,
    clientorganizationname: false,
    clientphonenumber: false,
    clientorganizationtype: false
  };
  
  showModal() {
    const button = document.getElementById('openModalBtn'); // Obtén el botón por su ID
    if (button) {
      button.click(); // Simula el clic en el botón
    } else {
      console.error('El botón no se encontró');
    }
  }

  // Torganizacion: Array<any>;
  ngOnInit() {

    

    this._formEntity = new FormGroup({
      clientfirstname: new FormControl({ value: '', disabled: false }, [Validators.required, Validators.maxLength(45)]),
      clientlastname: new FormControl({ value: '', disabled: false }, [Validators.required, Validators.maxLength(45)]),
      clientemail: new FormControl({ value: '', disabled: false }, [Validators.required, Validators.email, Validators.maxLength(45)]),
      clientorganizationname: new FormControl({ value: '', disabled: false }, [Validators.required, Validators.maxLength(45)]),
      clientphonenumber: new FormControl({ value: '', disabled: false }, [Validators.required, Validators.maxLength(45)]),
      clientorganizationtype: new FormControl({ value: '', disabled: false }, [Validators.required, Validators.maxLength(45)]),
      clientnumberofusers: new FormControl({ value: '0', disabled: false }, [])
    });

    this.GetCompanyTypes();


    this.Torganizacion = [
      { value: '1', label: 'BAS Contractor' },
      { value: '2', label: 'Electrical Contrator' },
      { value: '3', label: 'General Contrator' },
      { value: '4', label: 'Manufacturer' },
      { value: '5', label: 'Manufacturer Representative' },
      { value: '6', label: 'Mechanical Contrator' },
      { value: '7', label: 'Other' }
      ];

      this.nuser = [
        { value: '1', label: '5' },
        { value: '2', label: '6' },
        { value: '3', label: '7' },
        { value: '4', label: '8' },
        { value: '5', label: '9' },
        { value: '6', label: '10' },
        { value: '7', label: '11' },
        { value: '8', label: '12' },
        { value: '9', label: '50' }
        ];
  }

  GetCompanyTypes() {
    this.settings.GetCompanyTypes().subscribe(
      data => {
        this.companyTypes = data;
      },
      err => {

      }
    )
  }  

  changeCustomerType(a: any){}

  saveCompany(){
    console.log(this._formEntity);
    let client = this._formEntity.value
    if (!this.mycatchaResponse){
      this.toast.error('You must resolve catcha.');
      return 0;
    }    
    if (this._formEntity.status == 'INVALID'){
      this.toast.error('You must fill all fields with valid data.');
      return 0;
    }    
    this._formEntity.value.method = "Insert_TempUser";
    this.MapInformationService.MethodCallApiFlexUtility(this._formEntity.value).subscribe(
      data => {

        let info_email = {
          mailto: client.clientemail,
          address: client.clientemail,
          service: "Get_EmailTemplate_ClientTempUser",
          parameterxml: `<email>${client.clientemail}</email>`,
          subject: "Welcome to Cube USA!"
        }

        this.settings.SendNotificationClientTempUser(info_email).subscribe(resp => {

          // localStorage.setItem("idTempUser", data[0].ID);
          // this.toast.success("Your password has been sent to your email, please verify");
          setTimeout(() => {
            this.showModal(); 
          }, 1000);
          // this.popupSendEmail = true
          // this.router.navigateByUrl('/loginUserTemp');

        })



        // localStorage.setItem("newUserEmail", this._formEntity.value.clientemail);
        // this.companyTypes = data;

      },
      err => {

      }
    )    
  }


  SendEmailPopup(){
    this.popupSendEmail = false
    this.router.navigateByUrl('/loginUserTemp');
  }

  

  UserLogin(){
    console.log('al login')
    this.router.navigateByUrl('/loginUserTemp');
  }

}
